import { Route, Routes } from 'react-router-dom';

import { ROUTES } from 'base/routes/routes';

export const reportRoutes = ({
  RegistrationList,
  DeliveryResult,
  DeliveryRate,
  ReceivingSchedule,
  EmailSendingResult,
  WasteScrapSummary,
  RegistrationListWaste,
  TongHopKhoiLuongChatThaiNguyHai,
  ChatThaiCongNghiep
}: {
  // Danh sách xe đăng ký giao hàng
  RegistrationList: React.ComponentType;
  // Báo cáo kết quả giao hàng
  DeliveryResult: React.ComponentType;
  // Báo cáo tỷ lệ giao hàng đúng hẹn
  DeliveryRate: React.ComponentType;
  // Receiving Schedule of RHF
  ReceivingSchedule: React.ComponentType;
  //Báo cáo kết quả gửi email
  EmailSendingResult: React.ComponentType;
  // Waste & Scrap Summary
  WasteScrapSummary: React.ComponentType;
  // Báo cáo danh sách xe vào lấy chất thải
  RegistrationListWaste: React.ComponentType;
  // Báo cáo tổng hợp khối lượng chất thải nguy hại
  TongHopKhoiLuongChatThaiNguyHai: React.ComponentType;

  // Báo cáo tổng hợp khối lượng chất thải công nghiệp thông thường
  ChatThaiCongNghiep: React.ComponentType;
}) => (
  <Routes>
    {/* Báo cáo danh sách đăng ký xe giao hàng */}
    <Route path={ROUTES.REPORT.DELIVERY_REGISTRATION.BASE} element={<RegistrationList />} />
    {/* Báo cáo kết quả giao hàng */}
    <Route path={ROUTES.REPORT.DELIVERY_RESULT.BASE} element={<DeliveryResult />} />
    {/* Báo cáo tỷ lệ giao hàng thành công */}
    <Route path={ROUTES.REPORT.DELIVERY_RATE.BASE} element={<DeliveryRate />} />
    {/* Receiving schedule of BHF */}
    <Route path={ROUTES.REPORT.RECEIVING_SCHEDULE.BASE} element={<ReceivingSchedule />} />
    {/* Báo cáo kết quả gửi email */}
    <Route path={ROUTES.REPORT.EMAIL_SENDING_RESULT.BASE} element={<EmailSendingResult />} />
    {/* Waste & Scrap Summary */}
    <Route path={ROUTES.REPORT.WASTE_SCRAP_SUMMARY.BASE} element={<WasteScrapSummary />} />
    {/* Báo cáo danh sách xe vào lấy chất thải */}
    <Route path={ROUTES.REPORT.DELIVERY_REGISTRATION_WASTE.BASE} element={<RegistrationListWaste />} />

    {/* Báo cáo tổng hợp khối lượng chất thải nguy hại */}
    <Route path={ROUTES.REPORT.TONG_HOP_KHOI_LUONG_CHAT_THAI_NGUY_HAI.BASE} element={<TongHopKhoiLuongChatThaiNguyHai />} />

    {/* Báo cáo tổng hợp khối lượng chất thải công nghiệp thông thường */}
    <Route path={ROUTES.REPORT.CHAT_THAI_CONG_NGHIEP.BASE} element={<ChatThaiCongNghiep />} />
  </Routes>
);
